import { createActionGroup } from "@ngrx/store"
import { LeadInjector } from "../models/lead/lead-injector.model"
import { FacebookFormConfiguration } from "../models/social-forms-configurations/facebook-form-configuration.model"

export const LeadInjectorAction = createActionGroup({
    source: 'Shared',
    events: {
        'lead injector modified': (injector: LeadInjector) => ({ injector }),
        'lead injector created': (injector: LeadInjector) => ({ injector }),

        'social form facebook configuration modified': (configurationId: number) => ({ configurationId }),
        'social facebook form configuration created': (configurationId: number) => ({ configurationId }),
        'social facebook form configuration deleted': (configurationId: number) => ({ configurationId }),
    }
})
